function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DiscardOverlayTemplate = require('./discard.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var DiscardOverlay = /*#__PURE__*/function () {
  function DiscardOverlay(app, mod) {
    _classCallCheck(this, DiscardOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
  }
  return _createClass(DiscardOverlay, [{
    key: "render",
    value: function render() {
      var cardCt = this.mod.game.state.players[this.mod.game.player - 1].resources.length;
      if (cardCt <= 7) {
        return;
      }
      this.my_resources = {};
      this.targetCt = Math.floor(cardCt / 2);
      var _iterator = _createForOfIteratorHelper(this.mod.returnResources()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var resource = _step.value;
          var temp = this.mod.countResource(this.mod.game.player, resource);
          if (temp > 0) {
            this.my_resources[resource] = temp;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.overlay.show(DiscardOverlayTemplate(this.app, this.mod, this));
      this.overlay.blockClose();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var cardsToDiscard = [];
      document.querySelectorAll('.discard-cards-overlay .settlers-cards-container img').forEach(function (card) {
        card.onclick = function (e) {
          var target = e.currentTarget;
          var res = target.getAttribute('id');
          if (target.classList.contains('selected')) {
            var index = cardsToDiscard.indexOf(res);
            if (index > -1) {
              // only splice array when item is found
              cardsToDiscard.splice(index, 1); // 2nd parameter means remove one item only
            }
          } else {
            cardsToDiscard.push(res); //Add it to recycling bin
          }
          target.classList.toggle('selected');
          if (cardsToDiscard.length >= _this.targetCt) {
            for (var _i = 0, _cardsToDiscard = cardsToDiscard; _i < _cardsToDiscard.length; _i++) {
              var _card = _cardsToDiscard[_i];
              _this.mod.addMove("spend_resource\t".concat(_this.mod.game.player, "\t").concat(_card));
            }
            _this.mod.endTurn();
            _this.overlay.close();
          }
        };
      });

      // Set timer to auto-end my turn if I take too long
      //
      if (this.mod.turn_limit) {
        this.mod.clock.startClock(this.mod.turn_limit);
        this.mod.sleep_timer = setTimeout(function () {
          _this.overlay.close();
          var resources_available = _this.mod.game.state.players[_this.mod.game.player - 1].resources.slice();
          //remove already selected
          var _iterator2 = _createForOfIteratorHelper(cardsToDiscard),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var r = _step2.value;
              var _target = resources_available.indexOf(r);
              if (_target >= 0) {
                resources_available.splice(_target, 1);
              }
            }
            //Randomly select other resources
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          while (cardsToDiscard.length < _this.targetCt) {
            var target = Math.floor(Math.random() * resources_available.length);
            cardsToDiscard.push(resources_available.splice(target, 1));
          }
          var _iterator3 = _createForOfIteratorHelper(cardsToDiscard),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var card = _step3.value;
              _this.mod.addMove("spend_resource\t".concat(_this.mod.game.player, "\t").concat(card));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          _this.mod.endTurn();
        }, this.mod.turn_limit);
      }
    }
  }]);
}();
module.exports = DiscardOverlay;